import React from 'react'

import { Info } from 'lucide-react'
import { HiOutlineExclamationTriangle } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/common/TooltipV3'

interface CuiFieldNoticeProps {
  children: React.ReactNode
  className?: string
  side?: React.ComponentProps<typeof TooltipContent>['side']
  variant?: 'text' | 'icon'
}

const CuiFieldNotice: React.FC<CuiFieldNoticeProps> = ({
  children,
  className,
  side = 'top',
  variant = 'text',
}) => {
  if (variant === 'icon') {
    return (
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <span
            className={twMerge(
              'inline-flex h-5 w-5 shrink-0 items-center justify-center text-yellow-600 hover:text-yellow-700 dark:text-yellow-400 dark:hover:text-yellow-300',
              className,
            )}
            aria-label="CUI query warning"
          >
            <HiOutlineExclamationTriangle className="h-4 w-4" />
          </span>
        </TooltipTrigger>
        <TooltipContent
          className="max-w-72 text-xs leading-5"
          inverseColors={true}
          side={side}
        >
          {children}
        </TooltipContent>
      </Tooltip>
    )
  }

  return (
    <div
      className={twMerge(
        'flex items-start gap-1.5 text-xs leading-5 text-primary-500 dark:text-primary-400',
        className,
      )}
    >
      <Info className="mt-0.5 h-3.5 w-3.5 flex-shrink-0" />
      <span>{children}</span>
    </div>
  )
}

export default CuiFieldNotice
